import api from '@/api';

const resource = 'ei/calendario';

export default {
  getDatas(codigo, ano, mes) {
    return api.get(`${resource}/all`, { params: { ano, codigo, mes } });
  },
  getCalendarios(ano) {
    return api.get(`${resource}/listar/${ano}`);
  },
  getAnosCalendarios() {
    return api.get(`${resource}/listar-anos`);
  },
};
